var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_vm._v(" "),(!_vm.getAdmin)?_c('main',{staticClass:"main1 d-flex justify-content-center"},[_c('app-login')],1):_c('main',{staticClass:"main2 d-flex flex-wrap justify-content-around p-2"},[_c('app-menu',{staticClass:"w-100 w-md-30 w-lg-20"}),_vm._v(" "),_c('app-crud-card',{staticClass:"mt-3 mt-lg-0 w-100 w-md-65 w-lg-75"})],1),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48dfd55c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 497
// module chunks = 0